var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRecurringSmall = function SvgRecurringSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.648 29.352c19.136 19.135 19.136 50.16 0 69.296s-50.16 19.136-69.296 0a7 7 0 0 1 9.726-10.067l.173.168c13.669 13.668 35.83 13.668 49.498 0 13.668-13.669 13.668-35.83 0-49.498-13.532-13.531-35.387-13.667-49.085-.406l-.413.406a7 7 0 0 1-9.9-9.9c19.136-19.135 50.162-19.135 69.297 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.208 21.23 19.064 15.075 23.703 5.308a2 2 0 0 1 .559 3.686L22.502 66.551a2 2 0 0 1-2.971-1.427l-6.54-42.017a2 2 0 0 1 3.217-1.877"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecurringSmall);
export default ForwardRef;